import { render, staticRenderFns } from "./FireRisk.vue?vue&type=template&id=372473e2&"
import script from "./FireRisk.vue?vue&type=script&lang=js&"
export * from "./FireRisk.vue?vue&type=script&lang=js&"
import style0 from "./FireRisk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireRisk.vue"
export default component.exports